<template>
  <li
    class="flex items-start gap-3 px-3 py-3 cursor-pointer rounded-border hover:bg-emphasis transition-colors"
    :class="{ 'bg-blue-50': !notification.read_at }"
  >
    <div class="shrink-0 mt-1">
      <i :class="[notificationType.icon, 'text-primary']"></i>
    </div>
    <div class="flex-1 min-w-0">
      <div class="flex items-center gap-2">
        <span class="font-medium text-sm">{{ notification.title }}</span>
        <span
          v-if="!notification.read_at"
          class="w-2 h-2 rounded-full bg-primary shrink-0"
        ></span>
      </div>
      <p class="text-sm text-surface-500 m-0 mt-1 line-clamp-2">{{ notification.body }}</p>
      <span class="text-xs text-surface-400 mt-1 block">{{ timeAgo(notification.created_at) }}</span>
    </div>
  </li>
</template>

<script setup>
import { computed } from 'vue';
import { getNotificationType } from '@/notifications/notificationTypeRegistry';
import { timeAgo } from '@/utils/formatDate';

const props = defineProps({
  notification: {
    type: Object,
    required: true,
  },
});

const notificationType = computed(() => getNotificationType(props.notification.type));
</script>
